import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { Close } from '@mui/icons-material';

import RequestForm from '../forms/request/RequestForm';
import useAppStore from '../../store/app';

export default function NotFound() {
  const state = useAppStore((state) => state.hero);
  const handleGoBack = () => {
    window.history.back();
  };
  const completeRequestForm = useAppStore((state) => state.completeRequestForm);
  const theme = useTheme();

  const lg = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box
      id="hero"
      sx={{
        height: 'calc(100vh - 94px)',
        maxWidth: '1500px',
        width: '80%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '92px',
        [theme.breakpoints.down('md')]: {
          mt: '120px',
          flexDirection: 'column-reverse',
          justifyContent: 'flex-start',
          alignItems: 'center',
        },
        [theme.breakpoints.down('sm')]: {
          gap: '32px',
        },
      }}
    >
      <Box
        sx={{
          width: '500px',
          [theme.breakpoints.down('md')]: {
            pb: '20%',
          },
          [theme.breakpoints.down('sm')]: {
            width: '100%',
            px: '24px',
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: '800',
            fontSize: '48px',
            lineHeight: '1.2',
            [theme.breakpoints.down('sm')]: {
              fontSize: '28px',
            },
          }}
        >
          Leider wurde die von Ihnen angeforderte Seite nicht gefunden
        </Typography>

        <Typography
          sx={{
            fontWeight: '800',
            fontSize: '48px',
            lineHeight: '1.2',
            color: 'primary.main',
            [theme.breakpoints.down('sm')]: {
              fontSize: '28px',
            },
          }}
        >
          Error 404
        </Typography>

        <Typography
          sx={{
            mt: '22px',
            fontSize: '16px',
            [theme.breakpoints.down('sm')]: {
              fontSize: '14px',
            },
          }}
        >
          Über die folgende Schaltfläche gelangen sie zu dem von Ihnen zuletzt
          besuchten Bereich.
        </Typography>

        <Button
          color="primary"
          sx={{
            mt: '32px',
            width: '180px',
            fontSize: '16px',
            fontWeight: '700',
            border: '3px solid',
            borderRadius: '0',
            '&:hover': {
              border: '3px solid primary.main',
            },
          }}
          variant="outlined"
          onClick={() => handleGoBack()}
        >
          Zurück
        </Button>
      </Box>

      <Box
        sx={{
          flexShrink: 999,
          [theme.breakpoints.down('sm')]: {
            pt: '50px',
          },
        }}
      >
        {(state === 'graphics' || !lg) && (
          <img
            src="/static/page_not_found.svg"
            alt="Webdevelopment"
            style={{ maxWidth: '450px', width: '100%' }}
          />
        )}

        {state === 'form' && lg && <RequestForm />}
      </Box>

      <Dialog open={state === 'form' && !lg} onClose={completeRequestForm}>
        <Button
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
          }}
          onClick={completeRequestForm}
        >
          <Close />
        </Button>

        <DialogContent
          sx={{
            height: '50vh',
            minHeight: '550px',
            maxHeight: '90vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <RequestForm />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
